import React, { useEffect, useState } from 'react';

import { Container, Row, Col } from 'react-bootstrap';
import { ArrowRightCircle } from 'react-bootstrap-icons';
import TrackVisibility from 'react-on-screen';
import 'animate.css';

import HeaderImg from "../assets/img/header-img.svg";

const Banner = () => {
    const [loopNum, setLoopNum] = useState(0);
    const [isDeleting, setIsDeleting] = useState(false);
    const [text, setText] = useState('');
    // how fast text add or delete
    const [delta, setDelta] = useState(300 - Math.random() * 100);

    const toRotate = ["Web App Developer", "Mobile App Developer", "SEO Engineer"];

    //time that one word is shown or remove
    const period = 1000;

    const tick = () => {
        const i = loopNum % toRotate.length;
        let fullText = toRotate[i];
        let updatedText = isDeleting ? fullText.substring(0, text.length - 1) : fullText.substring(0, text.length + 1);

        setText(updatedText);

        if (isDeleting) {
            setDelta(prevDelta => prevDelta / 2);
        }

        if (!isDeleting && updatedText === fullText) {
            setIsDeleting(true);
            setDelta(period);
        } else if (isDeleting && updatedText === '') {
            setIsDeleting(false);
            setLoopNum(loopNum + 1);
            setDelta(500);
        }
    }

    useEffect(() => {
        let ticker = setInterval(() => {
            tick();
        }, delta);

        return () => {
            clearInterval(ticker);
        }
    }, [text]);

    return (
        <section className='banner' id='home'>
            <Container>
                <Row className='align-items-center'>
                    <Col xs={12} md={6} xl={7}>
                        <TrackVisibility>
                            {
                                ({ isVisible }) =>
                                    <div className={isVisible ? "animate__animated animate__fadeIn" : ""}>
                                        <span className='tagline'>Welcome to my Portfolio</span>
                                        <h1>{`Hi I'm M Waleed Khan `}<span className='wrap'>{text}</span></h1>
                                        <p>Hey There, My Name is Muhammad Waleed Khan And I am a Digital Evangelist, Frontend Web(JavaScript and ReactJS) and
                                            Mobile(Flutter, React Native) Application Developer.</p>
                                        <button onClick={() => console.log('Connect')}>Let's Connect <ArrowRightCircle size={25} /></button>
                                    </div>
                            }
                        </TrackVisibility>
                    </Col>
                    <Col xs={12} md={6} xl={5}>
                        <img src={HeaderImg} alt="Header" />
                    </Col>
                </Row>
            </Container>
        </section>
    )
}

export default Banner;